<template>
  <div>
   <!-- <AttendanceSummary :module_id="10" v-model="maximizeCard" /> -->
    <vx-card title="Select View" class="mb-4">
      <!-- <pre>{{courseList}}</pre> -->
      <div class="md:flex items-center">
        <!-- {{selectedCourseId}} -->
     <!--    <div class="p-1 lg:w-1/3 w-full">
          <v-select
            append-to-body
            class="w-full"
            label="name"
            :reduce="(option) => option.id"
            :options="courseList"
            v-model="selectedCourseId"
            :clearable="true"
            placeholder="Enter Course Name"
          ></v-select>
        </div> -->
        <!-- <pre> {{courseList}}</pre> -->

    <!--     <div class="p-1 lg:w-1/3 w-full">
          <v-select
            append-to-body
            class="w-full"
            label="first_name"
            :reduce="(option) => option.id"
            :options="teacherList"
            v-model="teacherId"
            :clearable="false"
            placeholder="Enter Teacher Name"
          ></v-select>
      
        </div>
 -->
      <!--   <div class="p-1 lg:w-1/3 w-full">
        
          <v-select
            append-to-body
            class="w-full"
            :getOptionLabel="(item) => `${item.first_name} ${item.last_name}`"
            :reduce="(option) => option.id"
            :options="students"
            v-model="studentId"
            :clearable="true"
            placeholder="Enter Student Name"
          ></v-select>
        </div> -->
        <div class="p-1 lg:w-1/3 w-full">
          <v-select
            append-to-body
            class="w-full"
            label="first_name"
            :options="attendanceTypeOptions"
            v-model="attendanceType"
            :clearable="false"
            placeholder="Attendance Type"
          ></v-select>
          
        </div>
        <div class="p-1 lg:w-1/3 w-full">
          <flat-pickr
            class="w-full"
            v-model="attendance_date"
            :config="configdateTimePickerTest"
            placeholder="Attendance Date"
          ></flat-pickr>
        </div>

        <div class="p-1 flex">
            <vs-button class="includeIcon includeIconOnly" @click.prevent="filterGoMethod()">Go</vs-button>

          <!-- <vs-tooltip text="Reset">
                        <vs-button type="border" icon-pack="feather" icon="icon-refresh-ccw" class="ml-2"></vs-button>
                    </vs-tooltip> -->
        </div>
      </div>
    </vx-card>

    <!-- {{filterPayload}} -->
    <teacherattendace-list :edit_permission="edit_permission" :is_archived="is_archived" :class_id="class_id" :filterPayload="filterPayload"></teacherattendace-list>
  </div>
</template>

<script>
// import AttendanceSummary from '../analytics/summeryLIst'
import vSelect from 'vue-select'
//you need to import the CSS manually
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { attendanceMixin } from './mixins/attendanceMixin'
import TeacherattendaceList from './TeacherattendaceList.vue'
export default {
  name: 'attendance',
  components: {
    vSelect,
    flatPickr,
    TeacherattendaceList
    // AttendanceSummary
  },
  mixins: [attendanceMixin],
  props: ['edit_permission', 'is_archived', 'class_id'],
  data () {
    return {
      maximizeCard:true,
      configdateTimePickerTest: {
        altInput: true,
        altFormat: 'j F, Y',
        // dateFormat: 'Y-m-d',
        wrap: true,
        dateFormat: 'Y-m-d'
      },
      filterPayload: {
        class_id: this.$route.params.class_id,
        start_date: this.$moment(new Date()).format('YYYY-MM-DD'),
        end_date: this.$moment(new Date()).format('YYYY-MM-DD'),
        teacher_id: null,
        client_user_id: null,
        attendance_type:'All'
      }
    }
  },
  methods: {
    editAttendance (indextr) {
      console.log(indextr)
      indextr.attendance = ''
      indextr.delayed_num = null
      indextr.delayed_input = true
    },

    filterGoMethod () {
      
      this.filterPayload.class_id = this.$route.params.class_id
      // this.filterPayload.teacher_id = this.teacherId
      // this.filterPayload.client_user_id = this.studentId
      this.filterPayload.start_date = this.attendance_date
      this.filterPayload.end_date = this.attendance_date
      this.filterPayload.attendance_type = this.attendanceType

      console.log(this.filterPayload)
      console.log('HI')
    }
  }
}
</script>
<style>
.attendance-badge {
  display: inline-block;
  margin: 5px 5px 5px 0;
  text-align: center;
  border-radius: 10rem;
  text-transform: capitalize;
  padding: 2px 10px;
  font-weight: 600;
}
.attendance-badge.present {
  background-color: rgba(40, 199, 111, 0.12);
  color: #28c76f !important;
}
.attendance-badge.absent {
  background-color: rgba(220, 53, 69, 0.12);
  color: #dc3545 !important;
}
.edit_att {
  font-size: 15px;
  cursor: pointer;
}
</style>